export default __webpack_public_path__ + "static/media/partners-logo-duoback-w.a9b54a5e.webp";